import React from 'react'
import { RadioButton } from '@mobi/component-library/Selection&Input/RadioButton'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { formatKambiCurrencyToDollarDecimal } from '@mobi/sports-offering/helpers/currency/currencyFormat'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getEventLinkForKambiClient } from '@core/Areas/KambiClient/helpers/navigation'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'
import { TeamsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon'
import { KambiHistoryCouponDisplayContext } from '@core/Areas/KambiSports/Player/Components/BetHistory/context'
import { CountdownStatus } from '../Common/CountdownStatus'
import { LegStatusIcon } from '../Common/LegStatusIcon'

export const Single: React.FC<{
  event: BetLoopKambiShareCoupon['events'][0]
  outcome: BetLoopKambiShareCoupon['outcomes'][0]
  betOffers: BetLoopKambiShareCoupon['betOffers']
  playedOdds: BetLoopKambiShareCoupon['couponRows'][0]['playedOdds']
  betStatus:
    | BetLoopKambiShareCoupon['bets'][0]['betStatus']
    | BetLoopKambiShareCoupon['couponRows'][0]['status']
  isWithinMultiBet?: boolean
  /** Used for quick share of single bet to Bet Loop */
  betRef?: BetLoopKambiShareCoupon['bets'][0]['betRef']
  onMultiLegCountdownReachingZero?(): void
}> = ({
  event,
  outcome,
  betOffers,
  playedOdds,
  betStatus,
  isWithinMultiBet,
  betRef,
  onMultiLegCountdownReachingZero,
}) => {
  const couponDisplayContext = React.useContext(KambiHistoryCouponDisplayContext)

  const isBetLoopQuickShare = couponDisplayContext.type === 'betloop-quick-share'
  const shouldDisplayQuickShareToggle = !isWithinMultiBet && isBetLoopQuickShare && betRef

  const { eventName, eventStartDate, eventId, sport, eventGroups } = event
  const heading = outcome.label
  const subHeading = betOffers[0].criterion
  const leagueId = eventGroups?.[eventGroups.length - 1]?.id
  const betOfferId = outcome.betOfferId
  const outcomeId = outcome.outcomeId
  const participantId = outcome.participantId

  return (
    <>
      <BetCard.EventDetails
        heading={eventName}
        iconComponent={<SportsIcon sport={sport} />}
        statusComponent={
          <>
            {(isWithinMultiBet && outcome.status === 'OPEN') || !isWithinMultiBet ? (
              <CountdownStatus
                displayType={isWithinMultiBet ? 'multi-leg' : 'standard'}
                eventStartTime={eventStartDate}
                betStatus={betStatus}
                onCountdownReachingZero={onMultiLegCountdownReachingZero}
              />
            ) : null}

            {shouldDisplayQuickShareToggle && (
              <RadioButton
                size='md'
                type='Tick'
                id={betRef.toString()}
                isChecked={couponDisplayContext.data.isSelected}
              />
            )}
          </>
        }
      />

      <BetCard.SelectionInfo
        // eslint-disable-next-line react/jsx-no-useless-fragment
        heading={<>{heading}</>}
        subHeading={subHeading}
        priceWin={playedOdds && formatKambiCurrencyToDollarDecimal(playedOdds)}
        linkInfo={{ pathname: getEventLinkForKambiClient(eventId) }}
        rightAlignedComponent={isWithinMultiBet && <LegStatusIcon status={outcome.status} />}
        iconComponent={
          <TeamsIcon
            size='2.4rem'
            leagueId={leagueId}
            participantId={participantId}
            betOfferType={betOffers[0].boTypeId}
            betOfferId={betOfferId}
            outcomeId={outcomeId}
            teamName={heading}
            sportName={sport}
          />
        }
      />
    </>
  )
}
